export default __webpack_public_path__ + "static/mark-f73d58e729b5d7a43b868fce43e7dd4c.png";